import React, {useEffect, useContext} from 'react'
import {Form, InputNumber} from "antd";
import {PurchaseContext} from "../../../context/PurchaseContext";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";

const PurchaseStockUnitPrice = ({record, rowIndex}) => {
    const [form] = Form.useForm()
    const {purchaseItems} = useContext(PurchaseContext)
    const [purchaseList, setPurchaseList] = purchaseItems

    useEffect(() => {
        if (Number(record.stock)) {
            form.setFieldsValue({unitPrice: record.unitPrice})
        }

    }, [record.stock])

    const handleUnitPriceChange = ({target: {value: val}}) => {
        const newList = replaceIndexAt(
            purchaseList,
            {
                ...purchaseList[rowIndex],
                unitPrice: val
            },
            rowIndex
        )
        setPurchaseList(newList)
    }

    return (
        <React.Fragment>
            <Form form={form}>
                <Form.Item
                    style={{marginBottom: 0}}
                    name={'unitPrice'}
                >
                    <InputNumber min={0} onBlur={handleUnitPriceChange}/>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default PurchaseStockUnitPrice